"use client";

import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { GooeyToaster, type GooeyToasterProps } from "goey-toast";

/**
 * The app's toaster, backed by goey-toast.
 *
 * Two things this wrapper has to do that the raw component does not:
 *
 * THEME. goey-toast accepts `theme: 'light' | 'dark'` only, while the app's
 * setting has a third value, "system". next-themes resolves that for us, but
 * only after mount — rendering the resolved value on the server would risk a
 * hydration mismatch, so the toaster waits for mount before rendering. Nothing
 * is lost: there is no toast to show on first paint.
 *
 * CLOSE BUTTON. sonner allowed `closeButton` per toast and three call sites
 * used it. goey-toast only has it here, so it is on globally — see the note in
 * lib/toast.tsx.
 *
 * The file keeps its old name so the import in layout.tsx stays valid; the
 * export is still `Toaster`.
 *
 * A canvas para este componente é tempo/designs/design-system/zunox/index.canvas.tsx.
 * Se alterar este componente de alguma forma, garanta que a canvas e a sua
 * declaração de asset se mantêm consistentes.
 */
const Toaster = (props: Omit<GooeyToasterProps, "theme">) => {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);
  if (!mounted) return null;

  return (
    <GooeyToaster
      theme={resolvedTheme === "dark" ? "dark" : "light"}
      closeButton
      showTimestamp
      {...props}
    />
  );
};

export { Toaster };
